import { useLocation, useNavigate } from "react-router-dom";
import { Phone, Sparkles } from "lucide-react";

const HIDDEN_PREFIXES = ["/login", "/admin", "/partner", "/product/", "/legal/"];

export default function MobileStickyCTA() {
  const loc = useLocation();
  const nav = useNavigate();

  if (HIDDEN_PREFIXES.some((p) => loc.pathname.startsWith(p))) return null;

  const scrollToQuote = () => {
    if (loc.pathname === "/") {
      // Home page has the quote form on top — scroll to it
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      nav("/");
      setTimeout(() => window.scrollTo({ top: 0, behavior: "smooth" }), 100);
    }
  };

  return (
    <div
      data-testid="mobile-sticky-cta"
      className="md:hidden fixed left-0 right-0 bottom-0 z-50 pb-[env(safe-area-inset-bottom)] pointer-events-none"
    >
      <div className="mx-3 mb-3 bg-white/95 backdrop-blur-xl border border-black/10 rounded-2xl shadow-[0_-8px_30px_-8px_rgba(0,0,0,0.15)] p-2 flex items-center gap-2 pointer-events-auto">
        <a
          href="tel:1800200200"
          data-testid="mobile-cta-call"
          className="flex-1 h-11 rounded-xl bg-white border border-black/10 grid place-items-center text-sm font-medium text-neutral-800 hover:bg-neutral-50 active:scale-[0.98] transition-transform"
        >
          <span className="inline-flex items-center gap-1.5">
            <Phone className="w-4 h-4" /> Call us
          </span>
        </a>
        <button
          onClick={scrollToQuote}
          data-testid="mobile-cta-quote"
          className="flex-[1.4] h-11 rounded-xl bg-[#0055FF] hover:bg-[#0044CC] active:scale-[0.98] transition-transform text-white text-sm font-semibold inline-flex items-center justify-center gap-1.5 shadow-lg shadow-[#0055FF]/30"
        >
          <Sparkles className="w-4 h-4" />
          Get free quote
        </button>
      </div>
    </div>
  );
}
